import React from "react";
// import Link from "@material-ui/core/Link";
import { Link } from "react-router-dom";
import firebase from "firebase";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Title from "../Title";

// Generate Recent Data
function createData(id, lastPlayed, name, email, maxScore, lastScore) {
  return { id, lastPlayed, name, email, maxScore, lastScore };
}

const rows = [];
function getUserData() {
  const db = firebase.firestore();
  var i = 0;
  db.collection("users")
    // .where("type", "==", "h")
    .orderBy("lastTime", "desc")
    .limit(10)
    .get()
    .then((querySnapshot) => {
      querySnapshot.forEach((doc) => {
        var date = doc.data().lastTime;
        var d = new Date(date);
        var ds = d.toString();
        rows[i] = createData(
          i,
          ds,
          doc.data().name,
          doc.data().email,
          doc.data().score,
          doc.data().lastScore
        );
        i++;
      });
    });
}

// function preventDefault(event) {
//   event.preventDefault();
// }

const useStyles = makeStyles((theme) => ({
  seeMore: {
    marginTop: theme.spacing(3),
  },
}));

export default function Recent(props) {
  const classes = useStyles();

  React.useEffect(() => {
    getUserData(props);
  }, []);

  return (
    <React.Fragment>
      <Title>Recent User List</Title>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>LastPlayed</TableCell>
            <TableCell>Name</TableCell>
            <TableCell>Email</TableCell>
            <TableCell>MaxScore</TableCell>
            <TableCell align="right">LastScore</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <TableRow key={row.id}>
              <TableCell>{row.lastPlayed}</TableCell>
              <TableCell>{row.name}</TableCell>
              <TableCell>{row.email}</TableCell>
              <TableCell>{row.maxScore}</TableCell>
              <TableCell align="right">{row.lastScore}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <div className={classes.seeMore}>
        <Link
          to="/admin_l7/users"
          style={{ color: "#3f51b5", textDecoration: "none" }}
        >
          See All Users
        </Link>
      </div>
    </React.Fragment>
  );
}
